'use strict';

import errorNotice from '../error';
import dataHandler from './../data-handler';
import { changeDates } from './../helpers';
import medicalSummary from './medical-summary';
//import hospitalized from './hospitalized';
//import hospitalizedPrimary from './hospitalized-primary';
//import hospitalizedSpecial from './hospitalized-special';
//import critical from './critical';
//import hospitalSpecial from './hospital-special';
//import hospitalPrimary from './hospital-primary';
import hospitalArea from './hospital-area';
import hospitalAge from './hospital-age';
import dead from './dead';
import deadMonth from './dead-month';
import deadCumulative from './dead-cumulative';

const medicalCharts = (function(){
    let dateDeadElems = null;
    let dateHospitalElems = null;

    function init(data) {
        dateDeadElems = document.querySelectorAll('.js-date-deaths');
        dateHospitalElems = document.querySelectorAll('.js-date-hospital');

        if (typeof data.hospital !== 'undefined' && data.hospital.weeks.length) {
            // Set first day values
            const deadChartFirstDay = dataHandler.getChartFirstDate(data.dead.days[0].date);
            window.config.firstDayValues['dead'] = deadChartFirstDay;
            const hospitalChartFirstDay = dataHandler.getChartFirstDate(data.hospital.weeks[0].date);
            window.config.firstDayValues['hospital'] = hospitalChartFirstDay;

            // Update chart date elems
            changeDates(deadChartFirstDay, dateDeadElems);
            changeDates(hospitalChartFirstDay, dateHospitalElems);

            // Init medical charts
            medicalSummary.init(data);
            //hospitalSpecial.init(data);
            //hospitalPrimary.init(data);
            hospitalArea.init(data);
            hospitalAge.init(data);
            /*hospitalized.init(data);
            critical.init(data);
            hospitalizedPrimary.init(data);
            hospitalizedSpecial.init(data);*/
            deadMonth.init(data);
            //dead.init(data);
            deadCumulative.init(data);
        } else {
            const error = 'Ongelma rajapinnassa, dataa ei saatavilla.';
            errorNotice.showDataError(error);
        }
    }

    function reload(data, page) {
        const reloadCharts = [];

        // Wave changed
        if (page.classList.contains('reload-wave')) {
            if (reloadCharts.indexOf('medical-summary') === -1) {
                reloadCharts.push('medical-summary');
            }
            page.classList.remove('reload-wave');
        }

        if (page.classList.contains('reload-date')) {
            // Update first day values
            const deadChartFirstDay = dataHandler.getChartFirstDate(data.dead.days[0].date);
            window.config.firstDayValues['dead'] = deadChartFirstDay;
            changeDates(deadChartFirstDay, dateDeadElems);

            const hospitalChartFirstDay = dataHandler.getChartFirstDate(data.hospital.weeks[0].date);
            window.config.firstDayValues['hospital'] = hospitalChartFirstDay;
            changeDates(hospitalChartFirstDay, dateHospitalElems);

            if (reloadCharts.indexOf('hospitalSpecial') === -1) {
                reloadCharts.push('hospitalSpecial');
            }
            if (reloadCharts.indexOf('hospitalPrimary') === -1) {
                reloadCharts.push('hospitalPrimary');
            }

            if (reloadCharts.indexOf('hospitalAge') === -1) {
                reloadCharts.push('hospitalAge');
            }
            if (reloadCharts.indexOf('hospitalArea') === -1) {
                reloadCharts.push('hospitalArea');
            }

            /*if (reloadCharts.indexOf('hospitalized') === -1) {
                reloadCharts.push('hospitalized');
            }
            if (reloadCharts.indexOf('hospitalizedPrimary') === -1) {
                reloadCharts.push('hospitalizedPrimary');
            }
            if (reloadCharts.indexOf('hospitalizedSpecial') === -1) {
                reloadCharts.push('hospitalizedSpecial');
            }
            if (reloadCharts.indexOf('critical') === -1) {
                reloadCharts.push('critical');
            }*/

            /*if (reloadCharts.indexOf('dead') === -1) {
                reloadCharts.push('dead');
            }*/
            if (reloadCharts.indexOf('medicalSummary') === -1) {
                reloadCharts.push('medicalSummary');
            }
            page.classList.remove('reload-date');
        }

        // Reload charts
        for (let chartType of reloadCharts) {
            if (chartType === 'medical-summary') {
                medicalSummary.reload(data);
            }
            if (chartType === 'hospitalSpecial') {
                //hospitalSpecial.reload(data);
            }
            if (chartType === 'hospitalPrimary') {
                //hospitalPrimary.reload(data);
            }
            if (chartType === 'hospitalAge') {
                hospitalAge.reload(data);
            }
            if (chartType === 'hospitalArea') {
                hospitalArea.reload(data);
            }
            /* if (chartType === 'hospitalized') {
                hospitalized.reload(data);
            }
            if (chartType === 'hospitalizedSpecial') {
                hospitalizedSpecial.reload(data);
            }
            if (chartType === 'hospitalizedPrimary') {
                hospitalizedPrimary.reload(data);
            }
            if (chartType === 'critical') {
                critical.reload(data);
            }*/
            /*if (chartType === 'dead') {
                dead.reload(data);
            }*/
            if (chartType === 'medicalSummary') {
                medicalSummary.reload(data);
            }
        }

        page.classList.remove('reload');
    }

    return {
        init,
        reload
    }
})();

export default medicalCharts;
